import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Ok bileşenleri
const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/40 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 19.5L8.25 12l7.5-7.5"
      />
    </svg>
  </button>
);

const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-white/20 hover:bg-white/40 text-white p-3 rounded-full transition-all duration-200 backdrop-blur-sm"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 4.5l7.5 7.5-7.5 7.5"
      />
    </svg>
  </button>
);

const HomeSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    appendDots: dots => (
      <div className="absolute bottom-4 w-full">
        <ul className="flex justify-center items-center gap-2"> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <button className="w-3 h-3 rounded-full bg-white/50 hover:bg-white transition-all duration-200">
        <span className="sr-only">{`Slide ${i + 1}`}</span>
      </button>
    ),
  };

  const slides = [
    {
      id: 1,
      image: '/assets/img/slider-1.webp',
      title: 'İstanbul 7/24 Kepenk Servisi',
      description: 'İşyeriniz için garantili kepenk tamiri ve bakımı',
    },
    {
      id: 2,
      image: '/assets/img/slider-2.webp',
      title: '7/24 Kepenk Servisi',
      description: 'Acil durumlar için kesintisiz teknik destek',
    },
    {
      id: 3,
      image: '/assets/img/slider-3.webp',
      title: 'Profesyonel Kepenk Tamiri',
      description: 'Uzman ekibimizle hızlı ve kalıcı çözümler',
    },
  ];

  return (
    <div className="w-full overflow-hidden relative">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={slide.id}>
            <div className="relative h-[60vh] min-h-[400px] max-h-[600px]">
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-full object-cover"
                loading={index === 0 ? 'eager' : 'lazy'}
                fetchpriority={index === 0 ? 'high' : 'auto'}
                decoding="async"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/20 flex items-center justify-center">
                <div className="text-center text-white px-4">
                  {index === 0 ? (
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
                      {slide.title}
                    </h1>
                  ) : (
                    <h2 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg">
                      {slide.title}
                    </h2>
                  )}
                  <p className="text-xl md:text-2xl drop-shadow-lg">{slide.description}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HomeSlider; 